/*
 * @Descripttion: 
 * @Author: panyufeng
 * @Date: 2025-07-04 09:48:11
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-07-04 09:48:46
 */
import service from '@/utils/request'

// 列表
export const editDisposeStatus = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/violation/editDisposeStatus',
    data: params
  })
